import styled from 'styled-components';

export const PlayDot = styled.div`
  height: 11px;
  width: 11px;
  border: solid 1px var(--gameday-play-dot-border);
  background-color: var(--gameday-play-dot-background);
  border-radius: 50%;
  position: absolute;
  left: ${({ $offset }) => $offset ? '-35px' : '12px'};
  top: 2px;
`;

export const PlayEventsWrapper = styled.div`
  font-family: var(--gameday-primary-font);
  position: relative;
  padding-left: ${({ $offset }) => !$offset ? '54px' : '0px'};
  padding-bottom: ${({ showPlayStatus }) => showPlayStatus ? '10px' : '0px'};
`;
